import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import { getRequestDiscoveryRequests } from "@/api/endpoints";
import { RequestQueueItem } from "@/pages/RequestsPage";

export function AllRequestsPage() {
  const requests = useApi(() => getRequestDiscoveryRequests(), []);
  const requestList = useMemo(() => requests.data?.data ?? [], [requests.data]);

  useEffect(() => {
    const interval = window.setInterval(() => {
      void requests.refetch();
    }, 15000);
    return () => window.clearInterval(interval);
  }, [requests]);

  return (
    <div className="requests-page">
      <section className="requests-history" aria-label="All requests">
        <div className="requests-all-header">
          <h1>All Requests</h1>
          <Link className="btn btn--ghost" to="/requests">
            ← Back to Requests
          </Link>
        </div>
        {requests.loading && <p className="settings-copy">Loading requests...</p>}
        {requests.error && (
          <p className="settings-status settings-status--error">Requests could not be loaded.</p>
        )}
        {!requests.loading && !requests.error && requestList.length === 0 && (
          <p className="requests-empty">No requests yet.</p>
        )}
        {requestList.length > 0 && (
          <div className="requests-list">
            {requestList.map((request) => (
              <RequestQueueItem key={request.id} request={request} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
